const initialGlobalUpdate = {
  global_update: false
};

export default  initialGlobalUpdate;